export default __webpack_public_path__ + "locales/ru/JavascriptSdk.json?hash=1ab4bf5872491c196c83085b97030f77";